module.exports = __webpack_public_path__ + "static/media/2018_vestec.df6eef29.png";